module.exports = __webpack_public_path__ + "img/brand-05.01cef8d9.png";